import * as React from "react";
import Icon from "common/icons";
// styles

const styles = require("./handlers.scss");

interface IProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  isBoosted?: boolean;
  className?: string;
}

const BoostHandler = (props: IProps) => {
  const { className, isBoosted = false, ...rest } = props;
  return (
    <div className={`${styles.wrapper} ${className}`} {...rest}>
      {isBoosted ? (
        <Icon icon="INTERESTS_BOOST_SELECT" />
      ) : (
        <Icon icon="INTERESTS_BOOST_NORMAL" />
      )}
    </div>
  );
};

export default BoostHandler;
